/**
 * Miniatura de producto: cuadrada, con proporción fija y sin imagen rota nunca.
 *
 * Estaba adentro de `Inventory.tsx`. Se sacó acá cuando el recortador de foto
 * llegó al inventario: `PhotoUploader` pintaba la vista previa con `Avatar`, o
 * sea REDONDA y con iniciales de persona — «JA» en un círculo azul para un
 * jabón—, mientras la lista de al lado lo mostraba cuadrado. Recortar un
 * producto en un cuadrado y mostrárselo redondo a 10 px del botón es la misma
 * clase de mentira que el recortador vino a arreglar.
 */

import { useEffect, useState } from 'react';

export function ProductThumb({ photoSrc, size = 40 }: { photoSrc: string | null; size?: number }) {
  const [broken, setBroken] = useState(false);
  // Igual que `Avatar`: se reintenta cuando cambia la foto, si no una carrera
  // perdida contra R2 deja la miniatura en el respaldo hasta recargar.
  useEffect(() => setBroken(false), [photoSrc]);
  const dim = { width: size, height: size, minWidth: size };

  if (photoSrc && !broken) {
    return (
      <img
        src={photoSrc}
        alt=""
        style={{ ...dim, objectFit: 'cover', borderRadius: 8, border: '1px solid var(--line)' }}
        onError={() => setBroken(true)}
      />
    );
  }
  return (
    <span
      style={{
        ...dim, display: 'grid', placeItems: 'center', borderRadius: 8,
        background: 'var(--surface-2)', border: '1px solid var(--line)', color: 'var(--muted-2)',
        fontSize: Math.round(size * 0.45),
      }}
      aria-hidden
    >
      ▣
    </span>
  );
}
